import { useEffect } from 'react'

const DEFAULT_SITE_URL = 'https://f1-elo-rankings.pages.dev'
// Optional env override for canonical/OpenGraph host (e.g. custom production domain).
const SITE_URL = (import.meta.env.VITE_SITE_URL || DEFAULT_SITE_URL).replace(/\/+$/, '')
const DEFAULT_OG_IMAGE = `${SITE_URL}/f1-logo.svg`

const setMetaTag = (selector, attributes) => {
  let meta = document.head.querySelector(selector)
  if (!meta) {
    meta = document.createElement('meta')
    Object.entries(attributes).forEach(([key, value]) => {
      if (key !== 'content') meta.setAttribute(key, value)
    })
    document.head.appendChild(meta)
  }
  meta.setAttribute('content', attributes.content)
}

const setCanonical = (href) => {
  let link = document.head.querySelector('link[rel="canonical"]')
  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }
  link.setAttribute('href', href)
}

const toAbsoluteUrl = (path = '/') => {
  if (/^https?:\/\//i.test(path)) {
    return path
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${SITE_URL}${normalizedPath}`
}

export default function usePageSeo({
  title,
  description,
  path = '/',
  openGraphType = 'website',
  image = DEFAULT_OG_IMAGE,
  noindex = false
}) {
  useEffect(() => {
    const canonicalUrl = toAbsoluteUrl(path)

    document.title = title
    setCanonical(canonicalUrl)

    setMetaTag('meta[name="description"]', { name: 'description', content: description })
    setMetaTag('meta[property="og:title"]', { property: 'og:title', content: title })
    setMetaTag('meta[property="og:description"]', { property: 'og:description', content: description })
    setMetaTag('meta[property="og:type"]', { property: 'og:type', content: openGraphType })
    setMetaTag('meta[property="og:url"]', { property: 'og:url', content: canonicalUrl })
    setMetaTag('meta[property="og:image"]', { property: 'og:image', content: toAbsoluteUrl(image) })

    setMetaTag('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' })
    setMetaTag('meta[name="twitter:title"]', { name: 'twitter:title', content: title })
    setMetaTag('meta[name="twitter:description"]', { name: 'twitter:description', content: description })
    setMetaTag('meta[name="twitter:image"]', { name: 'twitter:image', content: toAbsoluteUrl(image) })
    setMetaTag('meta[name="robots"]', {
      name: 'robots',
      content: noindex ? 'noindex, follow' : 'index, follow'
    })
  }, [title, description, path, openGraphType, image, noindex])
}
